<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <nz-range-picker [id]="code" [(ngModel)]="value" (ngModelChange)="inputChanged()" [nzDisabledDate]="disabledDate"
      nzFormat="yyyy-MMM-dd"
      [nzDisabled]="disabled">
    </nz-range-picker>
  </nz-form-control>
</nz-form-item>
